module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/76602ba3bf56e6ba492223964ae32e5a.png";